export const FACEBOOK_PUBLISHER = "facebook"
export const GOOGLE_PUBLISHER = "google"
export const TWITTER_PUBLISHER = "twitter"